import React from "react";

const GLHistory = ({
  history = [],
  loading = false,
  onOpen,
  lang,
}) => {
  if (loading) {
    return (
      <div className="text-center py-6 text-gray-400 text-sm">
        {lang === "hi" ? "लोड हो रहा है..." : "Loading..."}
      </div>
    );
  }

  if (!history.length) {
    return (
      <div className="text-center py-8 text-gray-500 text-sm">
        {lang === "hi"
          ? "अभी तक कोई Assessment उपलब्ध नहीं है।"
          : "No assessments available."}
      </div>
    );
  }

  return (
    <div className="space-y-2">
{/* <pre>{JSON.stringify(history, null, 2)}</pre> */}
      {history.map((item) => (
        <div
          key={item._id}
          className="bg-gray-900 border border-gray-700 rounded-lg p-3"
        >

          <div className="flex justify-between items-start">

            <div>

              <div className="text-sm font-semibold text-cyan-300">
                {item.childId?.name || "-"}
              </div>

              <div className="text-xs text-gray-400 mt-1">
                {item.childId?.grade || "-"}
                {item.childId?.age
                  ? ` • ${item.childId.age} yrs`
                  : ""}
              </div>

              <div className="text-xs text-gray-500 mt-1">
                {new Date(item.updatedAt).toLocaleString()}
              </div>

            </div>

            <button
              onClick={() => onOpen(item)}
              className="w-fit px-3 py-1 rounded bg-cyan-700 hover:bg-cyan-600 text-white text-xs"
            >
              {lang === "hi" ? "खोलें" : "Open"}
            </button>

          </div>

        </div>
      ))}

    </div>
  );
};

export default GLHistory;